module.exports = __webpack_public_path__ + "e5622582ff9f7af1bf641ae94a6ae0e6.svg";